import React, { useState, useEffect, useRef } from 'react';
import { HasPermission, CheckBox, FormContainer, Icon } from '../../components';
import {
  useGetClausesByProduct,
  useGetClausesByDocument
} from '../../services/ClausesService';
import { useGetProductOptions } from '../../services/QuestionnairesService';
import {
  ClausesContainer,
  ClauseGroupContainer,
  ClauseContent,
  IconsContainer
} from './styles';
import ClausesAccordion from "../ClausesAccordion";
import { Form, Formik } from 'formik';

export default function Clauses({
  idOperation,
  idProduct,
  idProductPlan,
  isInAnalysis,
  permission,
  isLoading,
  idDomainDocument,
  onSelectClauses,
  changeValueClause,
  noTitle,
  reloadClauses,
  overwriteQstValues,
  clauseVersionNumber
}) {
  const [clauseGroups, setClauseGroups] = useState([]);
  const [clauseGroupsDoc, setClauseGroupsDoc] = useState([]);
  const [selectedClauses, setSelectedClauses] = useState([]);
  const [productName, setProductName] = useState("");
  const formikRef = useRef();

  const {
    data: useGetClausesByProductData,
    loading: useGetClausesByProductLoading,
    error: useGetClausesByProductError,
    status: useGetClausesByProductStatus,
    request: useGetClausesByProductRequest,
  } = useGetClausesByProduct(idOperation);

  const {
    data: useGetClausesByDocumentData,
    loading: useGetClausesByDocumentLoading,
    error: useGetClausesByDocumentError,
    status: useGetClausesByDocumentStatus,
    request: useGetClausesByDocumentRequest,
  } = useGetClausesByDocument(idOperation);


  const {
    data: useGetProductOptionsData,
    loading: useGetProductOptionsLoading,
    error: useGetProductOptionsError,
    status: useGetProductOptionsStatus,
    request: useGetProductOptionsRequest,
  } = useGetProductOptions(idOperation);

  useEffect(() => {
    isLoading && isLoading(useGetClausesByProductLoading || useGetClausesByDocumentLoading || useGetProductOptionsLoading)
  }, [useGetClausesByProductLoading, useGetClausesByDocumentLoading, useGetProductOptionsLoading])

  useEffect(() => {
    if (useGetClausesByProductStatus === 200 && useGetClausesByDocumentStatus === 200) {
      if (useGetClausesByDocumentData?.value?.length && !reloadClauses) {
        const registeredClauses = [];
        for (const group of useGetClausesByDocumentData?.value || []) {
          registeredClauses.push(...group.clauses)
        }
        setSelectedClauses(registeredClauses);

        for (const group of useGetClausesByProductData?.value || []) {
          const documentGroup = useGetClausesByDocumentData.value?.find(v => v.idDomain === group.idDomain) || []
          if (documentGroup?.clauses?.length) {
            for (const clause of group.clauses) {
              const hasClause = documentGroup.clauses.find(v => v.idClause === clause.idClause);
              if (hasClause) {
                clause.clauseDescription = hasClause.clauseDescription || clause.clauseDescription
              }
            }
          }
        }

        setClauseGroupsDoc(useGetClausesByDocumentData.value);
        setClauseGroups(useGetClausesByProductData.value);
      } else {
        const clauses = [];
        for (const group of useGetClausesByProductData.value) {
          clauses.push(
            ...group.clauses
              .filter(clause => clause?.clauseBehavior?.isDefault)
          )
        }

        setSelectedClauses(clauses);
        setClauseGroups(useGetClausesByProductData.value)
      }
    }
  }, [useGetClausesByProductStatus, useGetClausesByDocumentStatus])

  useEffect(() => {
    if (isInAnalysis != null && idProduct != null) {
      console.log("123456ASDF", clauseVersionNumber)
      useGetClausesByProductRequest({ isInAnalysis, idProduct, idProductPlan, overwriteQstValues, clauseVersionNumber });
      useGetClausesByDocumentRequest(null, { idDomainDocument: idDomainDocument || 261, idProduct, idProductPlan, clauseVersionNumber });
    }

    if (idProduct) {
      useGetProductOptionsRequest(null, { idProduct }).then(({ data }) => {
        setProductName(data?.value?.productName)
      })
    }
  }, [isInAnalysis, idProduct, idProductPlan]);

  useEffect(() => {
    if (reloadClauses && isInAnalysis != null && idProduct != null) {
      useGetClausesByProductRequest({ isInAnalysis, idProduct, idProductPlan, overwriteQstValues, clauseVersionNumber });
    }
  }, [reloadClauses]);

  useEffect(() => {
    onSelectClauses && onSelectClauses(selectedClauses)
    let clausesChanged = selectedClauses.find(clause => clause.descriptionChanged)
    changeValueClause && changeValueClause(clausesChanged)
  }, [selectedClauses])

  const handleSelectClause = (clause) => {
    if (selectedClauses.find(v => v.idClause === clause.idClause)) {
      setSelectedClauses(selectedClauses.filter(v => v.idClause !== clause.idClause));
    } else {
      setSelectedClauses([
        ...selectedClauses,
        clause
      ]);
    }
  };

  const handleCheckSelectedClausesInGroup = (clauses) => {
    const idsClauses = selectedClauses.map(clause => (clause.idClause));
    const clause = clauses.find(clause => idsClauses.includes(clause.idClause));

    return clause;
  };

  const convertText = (description, adjustsDefault) => {
    if (adjustsDefault) {
      const entities = {
        '“a”': '&ldquo;a&rdquo;',
        '“CDI”': '&ldquo;CDI&rdquo;',
        '“b”': '&ldquo;b&rdquo;',
        '“c”': '&ldquo;c&rdquo;',
        '“SPE”': '&ldquo;SPE&rdquo;',
        '“pró-solvendo”': '&ldquo;pró-solvendo&rdquo;',
        '“ii”': '&ldquo;ii&rdquo;',
        '“i”': '&ldquo;i&rdquo;',
        '“lavagem”': '&ldquo;lavagem&rdquo;',
        " ": "",

      }
      for (const [entity, caracter] of Object.entries(entities)) {
        description = description.replace(new RegExp(entity, "g"), caracter);
      }

      return description
    } else {
      const entities = {
        " ": "",
        "\n": "",
        "&ordf;": "ª",
        "&ordm;": "º",
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&apos;": "'",
        "&Agrave;": "À",
        "&Aacute;": "Á",
        "&Acirc;": "Â",
        "&Atilde;": "Ã",
        "&Auml;": "Ä",
        "&Aring;": "Å",
        "&AElig;": "Æ",
        "&Ccedil;": "Ç",
        "&Egrave;": "È",
        "&Eacute;": "É",
        "&Ecirc;": "Ê",
        "&Euml;": "Ë",
        "&Igrave;": "Ì",
        "&Iacute;": "Í",
        "&Icirc;": "Î",
        "&Iuml;": "Ï",
        "&ETH;": "Ð",
        "&Ntilde;": "Ñ",
        "&Ograve;": "Ò",
        "&Oacute;": "Ó",
        "&Ocirc;": "Ô",
        "&Otilde;": "Õ",
        "&Ouml;": "Ö",
        "&Oslash;": "Ø",
        "&Ugrave;": "Ù",
        "&Uacute;": "Ú",
        "&Ucirc;": "Û",
        "&Uuml;": "Ü",
        "&Yacute;": "Ý",
        "&THORN;": "Þ",
        "&szlig;": "ß",
        "&agrave;": "à",
        "&aacute;": "á",
        "&acirc;": "â",
        "&atilde;": "ã",
        "&auml;": "ä",
        "&aring;": "å",
        "&aelig;": "æ",
        "&ccedil;": "ç",
        "&egrave;": "è",
        "&eacute;": "é",
        "&ecirc;": "ê",
        "&euml;": "ë",
        "&igrave;": "ì",
        "&iacute;": "í",
        "&icirc;": "î",
        "&iuml;": "ï",
        "&eth;": "ð",
        "&ntilde;": "ñ",
        "&ograve;": "ò",
        "&oacute;": "ó",
        "&ocirc;": "ô",
        "&otilde;": "õ",
        "&ouml;": "ö",
        "&oslash;": "ø",
        "&ugrave;": "ù",
        "&uacute;": "ú",
        "&ucirc;": "û",
        "&uuml;": "ü",
        "&yacute;": "ý",
        "&thorn;": "þ",
        "&yuml;": "ÿ",
        "&nbsp;": " ",
        "&ndash;": '–',
        "&deg;": '°',

      };

      for (const [entity, caracter] of Object.entries(entities)) {
        description = description.replace(new RegExp(entity, "g"), caracter);
      }

      return description;
    }

  }

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{}}
      validateOnChange={false}
      validateOnBlur={false}
      enableReinitialize={true}
    >
      {({ values, setFieldValue, errors, setFieldError }) => (
        <Form>
          <>
            {clauseGroups.length ?
              <FormContainer
                title={noTitle ? "" : `${productName || ""}`}
                noTitlePadding
                collapsedAtStart
              >
                <ClausesContainer>
                  {clauseGroups.map((group) => (
                    <ClauseGroupContainer
                      key={group.idDomain}
                      visible={
                        (
                          !permission &&
                          group.clauses.find(clause => clause.clauseBehavior?.isVisible || clause.clauseBehavior?.isVisible == null) &&
                          handleCheckSelectedClausesInGroup(group.clauses) &&
                          (
                            !clauseGroupsDoc.length ||
                            clauseGroupsDoc.find(groupDoc => groupDoc.idDomain === group.idDomain) ||
                            handleCheckSelectedClausesInGroup(group.clauses)
                          )
                        ) ||
                        permission &&
                        group.clauses.find(clause => clause.clauseBehavior?.isVisible || clause.clauseBehavior?.isVisible == null)
                      }
                    >
                      <h2 style={{ fontSize: '14px' }}>{group.idDomainDescription}</h2>
                      {group.clauses.map(clause => (
                        <ClauseContent
                          key={clause.idClause}
                          visible={clause.clauseBehavior?.isVisible || clause.clauseBehavior?.isVisible == null}
                        >
                          <CheckBox
                            checked={selectedClauses.find(v => v.idClause === clause.idClause)}
                            disabled={clause?.clauseBehavior?.isRequired || !permission}
                            onChange={() => handleSelectClause(clause)}
                          />
                          <ClausesAccordion
                            clause={clause}
                            idProduct={idProduct}
                            title={clause.clauseName}
                            description={clause.clauseDescription}
                            isEditable={clause.clauseBehavior?.isEditable && selectedClauses.find(v => v.idClause === clause.idClause)}
                            setFieldValue={setFieldValue}
                            values={values}
                            onClauseChange={(clause, value) => {
                              const updatedSelectedClauses = selectedClauses.map(v => {
                                if (clause.idClause === v.idClause) {
                                  v.clauseDescription = value;
                                  if (convertText(value, false) == convertText(v.defaultClauseDescription, true)) {
                                    v.descriptionChanged = false;
                                  } else {
                                    v.descriptionChanged = true;
                                  }
                                }
                                return v;
                              })

                              setSelectedClauses(updatedSelectedClauses)
                            }}
                            permission={permission}
                          />
                        </ClauseContent>
                      ))}
                    </ClauseGroupContainer>
                  ))}
                </ClausesContainer>
              </FormContainer>
              : <></>}
          </>
        </Form>
      )}
    </Formik>
  )
}